module.exports = {
    textTitleReg0: {
        //texture: '/img/scenes/regulation/text-0.png',
        texture: 'sprite:/img/scenes/regulation/sprite.json,regulation/text-0.png',
        scale: {
            x: '100%'
        }
    },

    textTitleReg1: {
        //texture: '/img/scenes/regulation/text-1.png',
        texture: 'sprite:/img/scenes/regulation/sprite.json,regulation/text-1.png',
        position: {
            x: '50%',
            y: '35%'
        },
        scale: {
            x: '100%'
        },
        anchor: {
            x: 0.5,
            y: 0.5
        }
    },

    textTitleReg2: {
        //texture: '/img/scenes/regulation/text-2.png',
        texture: 'sprite:/img/scenes/regulation/sprite.json,regulation/text-2.png',
        scale: {
            x: '100%'
        }
    },

    textTitleReg3: {
        //texture: '/img/scenes/regulation/text-3.png',
        texture: 'sprite:/img/scenes/regulation/sprite.json,regulation/text-3.png',
        scale: {
            x: '100%'
        }
    },

    textTitleReg4: {
        //texture: '/img/scenes/regulation/text-4.png',
        texture: 'sprite:/img/scenes/regulation/sprite.json,regulation/text-4.png',
        scale: {
            x: '100%'
        }
    },

    textTitleRegFr0: {
        // texture: '/img/scenes/regulation/text-0.png',
        texture: 'sprite:/img/scenes/regulation/sprite.json,regulation/text-0-fr.png',
        scale: {
            x: '100%'
        }
    },

    textTitleRegFr2: {
        // texture: '/img/scenes/regulation/text-2.png',
        texture: 'sprite:/img/scenes/regulation/sprite.json,regulation/text-2-fr.png',
        scale: {
            x: '100%'
        }
    },

    textTitleRegFr3: {
        // texture: '/img/scenes/regulation/text-3.png',
        texture: 'sprite:/img/scenes/regulation/sprite.json,regulation/text-3-fr.png',
        scale: {
            x: '100%'
        }
    },

    textTitleRegFr4: {
        // texture: '/img/scenes/regulation/text-4.png',
        texture: 'sprite:/img/scenes/regulation/sprite.json,regulation/text-4-fr.png',
        scale: {
            x: '100%'
        }
    },
};



// WEBPACK FOOTER //
// ./js/objects/titles/regulation.js